import { lazy } from 'react';
import { USER_ROLES } from 'constants/roles';

// Importing lazy-loaded components for different pages
const Chat = lazy(() => import('pages/admin/chat'));
const Report = lazy(() => import('pages/admin/report'));
const Calendar = lazy(() => import('pages/admin/calendar'));
const Dashboard = lazy(() => import('pages/admin/dashboard'));
const DashboardLayout = lazy(() => import('layout/dashboard'));
const ApplicantLayout = lazy(() => import('layout/applicant'));
const RefereeLayout = lazy(() => import('layout/referee'));
const ApplicantChat = lazy(() => import('pages/applicant/chat'));
const Position = lazy(() => import('pages/admin/settings/position'));
const Document = lazy(() => import('pages/admin/settings/documents'));
const RoleManagement = lazy(() => import('pages/admin/settings/roles'));
const Categories = lazy(() => import('pages/admin/settings/categories'));
const StaffMembers = lazy(() => import('pages/admin/staff-member/list'));
const Evaluation = lazy(() => import('pages/admin/settings/evaluation'));
const LeadSource = lazy(() => import('pages/admin/settings/lead-source'));
const Settings = lazy(() => import('pages/admin/settings/account-settings'));
const ChatSettings = lazy(() => import('pages/admin/settings/chat-settings'));
const ReferenceForm = lazy(() => import('pages/admin/settings/reference-form'));
const RefereeReferenceRequest = lazy(() =>
  import('pages/referee/reference-request')
);
const DeclineReferenceRequest = lazy(() =>
  import('pages/referee/reference-decline')
);
const RefereeRequestSubmitted = lazy(() =>
  import('pages/referee/request-response/request-submitted')
);
const RefereeRequestDeclined = lazy(() =>
  import('pages/referee/request-response/request-declined')
);
const ComplianceManager = lazy(() =>
  import('pages/admin/settings/compliance-manager')
);
const StaffMemberProfileDetails = lazy(() =>
  import('pages/admin/staff-member/profile-details')
);
const StaffMemberCompliance = lazy(() =>
  import('pages/admin/staff-member/compliance')
);
const StaffMemberReferences = lazy(() =>
  import('pages/admin/staff-member/references')
);
const StaffMemberActivityHistory = lazy(() =>
  import('pages/admin/staff-member/activity-history')
);
const StaffMemberDocuments = lazy(() =>
  import('pages/admin/staff-member/documents')
);
const StaffMemberSkillChecklist = lazy(() =>
  import('pages/admin/staff-member/skill-checklist')
);
const StaffMemberCompetencyTest = lazy(() =>
  import('pages/admin/staff-member/competency-test')
);
const StaffMemberEvaluation = lazy(() =>
  import('pages/admin/staff-member/evaluation')
);
const UserManagement = lazy(() =>
  import('pages/admin/settings/user-management')
);
const CompetencyTest = lazy(() =>
  import('pages/admin/settings/competency-test')
);
const OrganizationDetails = lazy(() =>
  import('pages/admin/settings/organization-details')
);
// const ProfileInformation = lazy(() =>
//   import('pages/applicant/profile-information')
// );
const SkillCheckList = lazy(() =>
  import('pages/admin/settings/skill-checklist')
);
const Applicant = lazy(() =>
  import('pages/applicant/stepper/wlecome-to-oncomply')
);
const VideoTraining = lazy(() =>
  import('pages/applicant/stepper/video-training')
);
const ProfileInformation = lazy(() =>
  import('pages/applicant/stepper/profile-information')
);
const WebpageLink = lazy(() => import('pages/applicant/stepper/webpage-link'));
const DocumentUpload = lazy(() =>
  import('pages/applicant/stepper/document-upload')
);
const ReferenceCheck = lazy(() =>
  import('pages/applicant/stepper/reference-check')
);
const CompetencyTestStep = lazy(() =>
  import('pages/applicant/stepper/competency-test')
);
const SkillChecklistStep = lazy(() =>
  import('pages/applicant/stepper/skill-checklist')
);
const ApplicationReview = lazy(() =>
  import('pages/applicant/stepper/application-review')
);
const AttemptTest = lazy(() =>
  import('pages/applicant/stepper/competency-test/attempt-test')
);
const TestResults = lazy(() =>
  import('pages/applicant/stepper/competency-test/test-results')
);
const ListGroups = lazy(() =>
  import('pages/applicant/stepper/skill-checklist/list-groups')
);
const SkillChecklistTest = lazy(() =>
  import('pages/applicant/stepper/skill-checklist/skill-checklist-test')
);
const SkillChecklistResults = lazy(() =>
  import('pages/applicant/stepper/skill-checklist/skill-checklist-results')
);
const TextInformation = lazy(() =>
  import('pages/applicant/stepper/text-information')
);

// onboarding components

// const Onboarding = lazy(() => import('pages/admin/settings/onboarding'));
const Onboarding = lazy(() => import('pages/admin/settings/onboarding-revamp'));

const defaultOnboardingScreen = lazy(() =>
  import('pages/admin/settings/onboarding/components/default-onboarding-screen')
);
const OnboardingSteps = lazy(() =>
  // import('pages/admin/settings/onboarding/listing-stepper')
  import('pages/admin/settings/onboarding-revamp/onboarding-steps')
);

const ViewDetailOnboarding = lazy(() =>
  // import('pages/admin/settings/onboarding/view-detail')
  import('pages/admin/settings/onboarding-revamp/view-onboarding')
);

const OnboardingListing = lazy(() =>
  import('pages/admin/settings/onboarding/listing')
);

// Array of protected routes
export const protectedRoutes = [
  // Onboarding routes

  {
    name: 'Onboarding',
    authenticated: true,
    component: Onboarding,
    layout: DashboardLayout,
    path: '/settings/onboarding',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  {
    name: 'Onboarding',
    authenticated: true,
    component: OnboardingListing,
    layout: DashboardLayout,
    path: '/settings/onboarding/list',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },

  {
    name: 'View Onboarding  Details',
    authenticated: true,
    layout: DashboardLayout,
    component: ViewDetailOnboarding,
    path: '/settings/onboarding/view/:id',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    name: 'Create Onboarding Steps',
    authenticated: true,
    layout: DashboardLayout,
    component: OnboardingSteps,
    path: '/settings/onboarding/create-steps/:id',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    name: 'Edit Onboarding Steps',
    authenticated: true,
    layout: DashboardLayout,
    component: OnboardingSteps,
    path: '/settings/onboarding/edit-steps/:id',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },

  {
    name: 'Calendar',
    path: '/calendar',
    component: Calendar,
    authenticated: true,
    layout: DashboardLayout,
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    name: 'Caregivers',
    authenticated: true,
    path: '/caregivers',
    component: StaffMembers,
    layout: DashboardLayout,
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    authenticated: true,
    layout: DashboardLayout,
    name: 'Caregiver-profile-details',
    component: StaffMemberProfileDetails,
    path: '/caregivers/profile-details/:id',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    authenticated: true,
    layout: DashboardLayout,
    name: 'Caregiver-documents',
    component: StaffMemberDocuments,
    path: '/caregivers/documents/:id',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    authenticated: true,
    layout: DashboardLayout,
    name: 'Caregiver-activity',
    component: StaffMemberActivityHistory,
    path: '/caregivers/activity-history/:id',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    authenticated: true,
    layout: DashboardLayout,
    name: 'Caregiver-references',
    component: StaffMemberReferences,
    path: '/caregivers/references/:id',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    authenticated: true,
    layout: DashboardLayout,
    name: 'Caregiver-skill-checklist',
    component: StaffMemberSkillChecklist,
    path: '/caregivers/skill-checklist/:id',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    authenticated: true,
    layout: DashboardLayout,
    name: 'Caregiver-competency-test',
    component: StaffMemberCompetencyTest,
    path: '/caregivers/competency-test/:id',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    authenticated: true,
    layout: DashboardLayout,
    name: 'Caregiver-evaluation',
    component: StaffMemberEvaluation,
    path: '/caregivers/evaluation/:id',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    authenticated: true,
    layout: DashboardLayout,
    name: 'Caregiver-compliance',
    component: StaffMemberCompliance,
    path: '/caregivers/compliance/:id',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    name: 'Settings',
    path: '/settings',
    component: Settings,
    authenticated: true,
    layout: DashboardLayout,
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    name: 'Dashboard',
    path: '/dashboard',
    authenticated: true,
    component: Dashboard,
    layout: DashboardLayout,
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    name: 'Report',
    path: '/report',
    authenticated: true,
    component: Report,
    layout: DashboardLayout,
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    name: 'Chat',
    path: '/chat',
    component: Chat,
    authenticated: true,
    layout: DashboardLayout,
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    authenticated: true,
    layout: DashboardLayout,
    name: 'Organization-details',
    component: OrganizationDetails,
    path: '/settings/organization-details',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  {
    authenticated: true,
    name: 'Referral-source',
    component: LeadSource,
    layout: DashboardLayout,
    path: '/settings/referral-source',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  {
    name: 'Documents',
    component: Document,
    authenticated: true,
    layout: DashboardLayout,
    path: '/settings/documents',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  {
    authenticated: true,
    name: 'Reference-form',
    component: ReferenceForm,
    layout: DashboardLayout,
    path: '/settings/reference-form',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  {
    name: 'Position',
    authenticated: true,
    component: Position,
    layout: DashboardLayout,
    path: '/settings/position',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },

  {
    authenticated: true,
    name: 'Role-management',
    layout: DashboardLayout,
    component: RoleManagement,
    path: '/settings/role-management',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  {
    authenticated: true,
    name: 'User-management',
    layout: DashboardLayout,
    component: UserManagement,
    path: '/settings/user-management',
    permission: [USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.ORGANIZATION_USER],
  },
  {
    authenticated: true,
    name: 'Competency-test',
    layout: DashboardLayout,
    component: CompetencyTest,
    path: '/settings/competency-test',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  {
    name: 'Evaluation',
    authenticated: true,
    component: Evaluation,
    layout: DashboardLayout,
    path: '/settings/evaluation',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  {
    authenticated: true,
    name: 'Skill-checklist',
    layout: DashboardLayout,
    component: SkillCheckList,
    path: '/settings/skill-checklist',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  {
    name: 'Categories',
    authenticated: true,
    component: Categories,
    layout: DashboardLayout,
    path: '/settings/categories',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  {
    authenticated: true,
    layout: DashboardLayout,
    name: 'Compliance-manager',
    component: ComplianceManager,
    path: '/settings/compliance-manager',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  {
    authenticated: true,
    name: 'Chat-settings',
    layout: DashboardLayout,
    component: ChatSettings,
    path: '/settings/chat-settings',
    permission: [USER_ROLES.ORGANIZATION_ADMIN],
  },
  // {
  //   authenticated: true,
  //   layout: DashboardLayout,
  //   name: 'Profile-information',
  //   component: ProfileInformation,
  //   permission: [USER_ROLES.APPLICANT],
  //   path: '/applicant/profile-information',
  // },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'Appliacnt',
    component: Applicant,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/welcome-to-oncomply',
  },
  {
    name: 'Chat',
    authenticated: true,
    path: '/applicant/chat',
    layout: DashboardLayout,
    component: ApplicantChat,
    permission: [USER_ROLES.APPLICANT],
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'VideoTraining',
    component: VideoTraining,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/video-training',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'ProfileInformation',
    component: ProfileInformation,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/profile-information',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'WebpageLink',
    component: WebpageLink,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/webpage-link',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'DocumentUpload',
    component: DocumentUpload,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/document-upload',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'ReferenceCheck',
    component: ReferenceCheck,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/reference-check',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'CompetencyTestStep',
    component: CompetencyTestStep,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/competency-test',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'AttemptTest',
    component: AttemptTest,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/competency-test/:id',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'SkillChecklistStep',
    component: SkillChecklistStep,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/skill-checklist',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'ApplicationReview',
    component: ApplicationReview,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/application-review',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'TestResults',
    component: TestResults,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/competency-test/results',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'ListGroups',
    component: ListGroups,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/skill-checklist/:id/checklist-detail',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'SkillChecklistTest',
    component: SkillChecklistTest,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/skill-checklist/:id/checklist-detail/:id/skill',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'SkillChecklistResults',
    component: SkillChecklistResults,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/skill-checklist/results',
  },
  {
    authenticated: true,
    layout: ApplicantLayout,
    name: 'TextInformation',
    component: TextInformation,
    permission: [USER_ROLES.APPLICANT],
    path: '/applicant/text-information',
  },
  {
    authenticated: false,
    layout: RefereeLayout,
    name: 'Referee',
    component: RefereeReferenceRequest,
    permission: [],
    path: '/referee/reference-request',
  },
  {
    authenticated: false,
    layout: RefereeLayout,
    name: 'Referee',
    component: DeclineReferenceRequest,
    permission: [],
    path: '/referee/decline-reference',
  },
  {
    authenticated: false,
    layout: RefereeLayout,
    name: 'Referee',
    component: RefereeRequestDeclined,
    permission: [],
    path: '/referee/reference-declined',
  },
  {
    authenticated: false,
    layout: RefereeLayout,
    name: 'Referee',
    component: RefereeRequestSubmitted,
    permission: [],
    path: '/referee/reference-submitted',
  },
];
